<template>
  <Modal
    @close="closeModal()"
    :closeIcon="true"
    size="sm"
    :withoutFooter="true"
    class="select-none"
  >
    <div slot="body">
      <Heading>New Promotion Instance</Heading>

      <div class="mt-8">
        <fieldset>
          <label for="name">Instance Name<small>*</small></label>
          <input
            type="text"
            class="input mt-2"
            id="name"
            v-model="form.name"
            required
          />
        </fieldset>
      </div>

      <div class="mt-4">
        <fieldset>
          <label for="url">URL<small>*</small></label>
          <input
            type="text"
            class="input mt-2"
            id="url"
            v-model="form.url"
            required
          />
        </fieldset>
      </div>

      <div class="mt-4">
        <fieldset>
          <label for="url">Title<small>*</small></label>
          <input
            type="text"
            class="input mt-2"
            id="title"
            v-model="form.title"
            required
          />
        </fieldset>
      </div>

      <div class="mt-4">
        <fieldset>
          <label for="url">Description<small>*</small></label>
          <VueEditor class="mt-2" v-model="form.description" />
        </fieldset>
      </div>

      <div class="mt-4">
        <label for="url">Logo<small>*</small></label>
        <FilePicker
          :value="filePreview"
          @change="
            file => {
              form.logo = file
            }
          "
        />
      </div>

      <div class="flex justify-between mt-8">
        <StyledButton @click="submit()" type="primary">Save</StyledButton>
        <StyledButton @click="closeModal()">Cancel</StyledButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import Heading from '@/components/common/Heading'
import StyledButton from '@/components/common/controls/StyledButton'
import { VueEditor } from 'vue2-editor'
import FilePicker from '@/components/common/controls/FilePicker'
import ApiV1 from '@/api/api_v1.0.js'

export default {
  name: 'CreateUpdatePromotionModal',
  props: {
    promotion: {
      type: Object,
      required: false,
    },
  },
  components: {
    Modal,
    Heading,
    StyledButton,
    VueEditor,
    FilePicker,
  },

  data() {
    return {
      form: {
        name: '',
        url: '',
        title: '',
        description: '',
        logo: null,
      },
    }
  },

  created() {
    if (this.promotion) {
      this.form = this.promotion
    }
  },

  computed: {
    filePreview() {
      return this.promotion && typeof this.promotion.logo == 'string'
        ? this.promotion.logo
        : ''
    },
  },

  methods: {
    async submit() {
      let data = new FormData()

      for (let a in this.form) {
        if (a === 'logo' && typeof this.form[a] == 'object') {
          data.append('file', this.form[a])
        }
        data.append(a, this.form[a])
      }

      if (this.promotion) {
        // update
        await ApiV1.updatePromotion(data)
      } else {
        await ApiV1.createPromotion(data)
      }

      this.showGlobalSuccessMessage('Saved')
      this.$emit('refresh')
      setTimeout(() => {
        this.closeModal()
      },2000);
    },

    closeModal() {
      this.$emit('close')
    },
  },
}
</script>
